// Cầu nối 1 chiều giữa axios interceptor (không nằm trong cây React nên không
// dùng được useNavigate) và App: khi phiên đăng nhập hết hiệu lực, interceptor
// gọi notifySessionExpired() còn App tự quyết định điều hướng + hiện thông báo.
// Trước đây interceptor gọi thẳng window.location.href='/login' -> RELOAD cả app,
// mất dữ liệu user đang nhập dở và nháy trắng màn hình.

let handler = null;

/** App đăng ký hành vi khi mất phiên (điều hướng mềm + toast). Gọi 1 lần lúc mount. */
export const onSessionExpired = (fn) => {
    handler = fn;
};

/** Interceptor báo mất phiên. Chưa đăng ký handler thì bỏ qua (không nổ). */
export const notifySessionExpired = () => {
    if (typeof handler === 'function') handler();
};
